import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FasDirective, MDBModalRef, ToastService } from 'ng-uikit-pro-standard';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';
declare var $: any;

@Component({
  selector: 'app-new-contact',
  templateUrl: './new-contact.component.html',
  styleUrls: ['./new-contact.component.scss']
})
export class NewContactComponent implements OnInit {

  text = '1';
  action: Subject<any> = new Subject<any>();
  customerSelect = [];
  optionsCountry = [];

  validatingFormContact: FormGroup;
  iscCstomerAddress = false;

  @Input() popupNewContact = false;
  @Input() VieneDe:any;
  @Output() closemodal = new EventEmitter();
  @Output() onsave = new EventEmitter();
  modalRef = new MDBModalRef();
  // @Output() outContactId = new EventEmitter<any>();


  cancelButton: any;
  saveButton: any;
  saveNewButton: any;
  saveEditButton: any;
  constructor(
    //public modalRef: MDBModalRef,
    private contactService: ContactService,
    private toast: ToastService,
    private router: Router,
    public MapInformationService:MapInformationService
    ) { }

  ngOnInit() {
    this.clearForm();
    this.GetContactCountries();
    this.getCustomer();
    setTimeout(() => {
      $('.modal').css('overflow-y', 'auto');
    }, 1000);


    this.cancelButton = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupNewContact = false;
      },
    };

    this.saveButton = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.save(true, true);
      },
    };

    this.saveNewButton = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.save(false, true);
      },

    };

    this.saveEditButton = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.save(false, false, true);
       //  this.submitForm(true, true);
      },
    };

  }

  save(cierramodal, limpiacampos, goEdit = false) {
    let value = this.validatingFormContact.value;
    value.Id = 0;
    value.CustomerID = value.CustomerID ? value.CustomerID : 0;
    console.log('values', value);
    this.contactService.SaveContact(value).subscribe(result => {
      this.toast.success('People Created Successfully.');
      // this.outContactId.emit(result.Result);

      let obj = {
        id: result[0].Result,
        First: this.validatingFormContact.get('FirstName').value ? this.validatingFormContact.get('FirstName').value : '',
        Last: this.validatingFormContact.get('LastName').value ? this.validatingFormContact.get('LastName').value : ''
      }

      if (limpiacampos) {
        this.clearForm();
      }

      if (cierramodal) {
        // this.modalRef.hide();
        this.closemodal.emit();
      }

      if (goEdit) {
        this.router.navigateByUrl('/contacts/editContact/' + result[0].Result);
        // this.modalRef.hide();
        this.closemodal.emit();
      }

      // this.get(true);
      // this.action.next({success: true, data: result[0].Result});

      this.onsave.emit(obj);
    },
    error => {
      this.toast.error('Error saving contact');
      this.action.next({success: false, data: null});
    });

  }

  clearForm() {
    this.iscCstomerAddress = false;
    this.validatingFormContact = new FormGroup({
      FirstName: new FormControl(null, [Validators.required, Validators.maxLength(30),Validators.pattern('[a-zA-Z ]*')]),
      LastName: new FormControl(null, [Validators.required, Validators.maxLength(30),Validators.pattern('[a-zA-Z ]*')]),
      Nickname: new FormControl(null, []),
      CustomerID: new FormControl(null, []),
      Department: new FormControl(null, []),
      JobTitle: new FormControl(null, []),
      WebPage: new FormControl(null, [ Validators.pattern("(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?")]),
      Comments: new FormControl(null, [Validators.maxLength(250)]),
      // Address: new FormControl(null, []),
      // MobilePhone: new FormControl(null, []),
      // Country: new FormControl(null, []),
      // City: new FormControl(null, []),
      // State: new FormControl(null, []),
      // Zip: new FormControl(null, []),
      Email: new FormControl(null, [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      // HomePhone: new FormControl(null, []),
      // Phone: new FormControl(null, []),
      // Business2Phone: new FormControl(null, []),
      // OtherFax: new FormControl(null, []),
      // PHONEEXT1: new FormControl(null, []),
      // PHONEEXT2: new FormControl(null, []),
      // OffFax: new FormControl(null, []),
      // lon: new FormControl(null, []),
      // lat: new FormControl(null, []),
    });
  }

  cancelCreateContact() {
    this.clearForm();
    this.closemodal.emit();
    // this.modalRef.hide();
  }

  changeAddress() {
    // this.iscCstomerAddress = !this.iscCstomerAddress;

    if (this.iscCstomerAddress) {
      let id = this.validatingFormContact.get('CustomerID').value;

      if (!id) {
        id = 0;
      }

      this.contactService.GetCustomer(id).subscribe(result => {
        console.clear();
        console.log('customer', result[0]);
        const val = result[0];

        this.validatingFormContact.get('Address').setValue(val.ADDRESS);
        this.validatingFormContact.get('Country').setValue(val.COUNTRY);
        this.validatingFormContact.get('City').setValue(val.CITY);
        this.validatingFormContact.get('State').setValue(val.STATE);
        this.validatingFormContact.get('Zip').setValue(val.ZIP);
      });
    }
  }

  GetContactCountries() {
    this.contactService.GetContactCountries().subscribe(result => {
      this.optionsCountry = result.map((val) => {
        return { // Return the new object structure
          label: val.COUNTYNAME,
          value: val.CountryISO3
        };
      });
    });
  }

  getCustomer() {
    // this.contactService.GetCustomer().subscribe(result => {
      this.MapInformationService.SaveInfoSites({method:"Get_CustomerCE"}).subscribe(result => {
      console.log('customer', result);
      this.customerSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.DESCRIPTION,
          value: val.ID
        };
      });
    });
  }

  handleAddressChange(res){
    console.log(res);
    this.validatingFormContact.get('lon').setValue(res.geometry.location.lng());
    this.validatingFormContact.get('lat').setValue(res.geometry.location.lat());
    this.validatingFormContact.get('Address').setValue(res.formatted_address);
    // this.userSetting.long = res.geometry.location.lng();
    // this.userSetting.lat = res.geometry.location.lat();
    // this.userSetting.geoname = res.formatted_address;
  }



}
